import { Button, Card, Header } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import AddUserLanguageModal from "../../../../account/views/AccountSettingsView/components/AddUserLanguageModal";
import UserLanguagesTable from "../../../../users/components/UserLanguagesTable/UserLanguagesTable";

export default function UserLanguageSkills({ user }) {
	const { t } = useTranslation();

	const [openModal, setOpenModal] = useState(false);

	return (
		<>
			<Header as="h3">{t("languageSkills", "Language skills")}</Header>

			<Card fluid>
				<Card.Content>
					<UserLanguagesTable user={user} />
				</Card.Content>

				<Card.Content>
					<Button primary onClick={() => setOpenModal(true)}>
						{t("add", "Add")}
					</Button>
				</Card.Content>
			</Card>

			{openModal && <AddUserLanguageModal user={user} onClose={() => setOpenModal(false)} />}
		</>
	);
}
